import L from "leaflet";

export default () => {
  const containers = document.querySelectorAll('[data-map]');

  for (const mapContainer of containers) {
    const locations = JSON.parse(mapContainer.getAttribute('data-locations'));
    if (locations.length > 0) {

      const map = L.map(mapContainer, {
        center: [locations[0].lat, locations[0].lng],
        zoom: 18,
        scrollWheelZoom: false
      });

      L.tileLayer('https://api.mapbox.com/styles/v1/nivankafonseka/cky9ei3ua3r9514qwoyf0ltt4/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoibml2YW5rYWZvbnNla2EiLCJhIjoiY2t5OWVtcDl4MDVvNzJubW5yNGN2dGI4MyJ9.28FLF_e0rkyYxJxM7P-jsQ', {
        maxZoom: 18,
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: 'pk.eyJ1Ijoibml2YW5rYWZvbnNla2EiLCJhIjoiY2piZXVqYjZmMnVqODMzcWdnNHRtNnpldCJ9.KsvDzV4jUau13c_RclgMmw'
      }).addTo(map);

      const bounds = L.latLngBounds();

      locations.forEach(function (location) {
        const coords = [location.lat, location.lng];
        L.marker(coords)
          .bindTooltip(location.address, { permanent: false, direction: "top", offset: L.point(-15, -15) })
          .addTo(map);
        bounds.extend(coords);
      });

      map.fitBounds(bounds, { padding: [50, 50] });
    }

  }

}
